import { Component, Input } from '@angular/core';


/**
 * Reusable Auth Left Panel Component
 * Used in all authentication pages (login, register, forgot-password, etc.)
 * Displays background image on the left side of auth layout
 */
@Component({
  selector: 'app-auth-left-panel',
  standalone: true,
  imports: [],
  template: `
    <div [class]="'login-image ' + additionalClass">
      @if (imageSrc) {
        <img [src]="imageSrc" [alt]="imageAlt" />
      }
    </div>
    `
})
export class AuthLeftPanelComponent {
  /**
   * Path to the background image
   * Example: 'assets/images/airport.png'
   */
  @Input() imageSrc?: string;

  /**
   * Alt text for the image
   * Default: 'Background'
   */
  @Input() imageAlt: string = 'Background';

  /**
   * Additional CSS classes for variants
   * Example: 'verification-bg', 'reset-bg'
   */
  @Input() additionalClass: string = '';
}
